<template>
    <div class="form-check">
        <input class="form-check-input" 
                type="checkbox" 
                :value="value" 
                :name="name"
                v-model="inputVal"
                id="id"
                :disabled="disabled"
        >
        <label class="form-check-label" :for="name" >
            <slot/>
        </label>
    </div>
</template>
<script>
export default {
    props:{
        id: {
            type: String,
        },
        name: {
            type: String,
        },
        value:{
            type: String,
        },
        for: {
            type: String,
        },
        modelValue: {
            type: [String, Boolean]
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    name:"OCheckBox",
    computed: {
        inputVal: {
            get() {
                return this.modelValue;
            },
            set(val) {
                this.$emit('update:modelValue', val);
            }
        }
    }
}

// Ref : 
// https://stackoverflow.com/questions/47311936/v-model-and-child-components
// https://v3.vuejs.org/guide/migration/v-model.html
</script>

<style scoped>
.form-check-input:focus {
    border-color: var(--primary-color, #F93E3E) !important;
    box-shadow: 0 0 0 0.25rem var(--secondary-color, #FEE9E9) !important;
}

.form-check-input:checked {
    background-color: var(--primary-color, #F93E3E) !important;
    border-color: var(--primary-color, #F93E3E) !important;
}
</style>